import { SearchCustomerContactsRes_Result } from "gen/search/service/service_pb"

import { useSearchCustomerContacts } from "features/api/search"

import { useWebFilter, UseWebFilterProps } from "./useWebFilter"

type KeyExtractor = (result: SearchCustomerContactsRes_Result) => string

const defaultKeyExtractor: KeyExtractor = (result) =>
  result.contact?.idString ?? ""

export function useContactFilter({
  key = "contact",
  persistInUrl = true,
  initialSelectedOptions = [],
  keyExtractor = defaultKeyExtractor,
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "initialSelectedOptions"
  >
> & { keyExtractor?: KeyExtractor } = {}) {
  const { results, setQuery, loadNext } = useSearchCustomerContacts()

  const { filter, selectedKeys } = useWebFilter({
    key,
    label: "Contact name",
    values: results,
    keyExtractor,
    labelExtractor: (result) => result.contact?.name ?? "",
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    persistInUrl,
    initialSelectedOptions,
    onLoadMore: loadNext,
  })

  return { filter, selectedKeys }
}
